import SaveWithPanelColorToggle from '../PanelColor/SaveWithPanelColorToggle';
import { PanelElement } from '../style';

export default function AdjustPanelColorToggle(props: {isB2C?: boolean}) {
	return (<PanelElement style={{ zIndex: 0 , padding: props?.isB2C ? '10px 0 12px': '0', width: props?.isB2C ? 'calc(100% - 0.5rem)': '100%' }}>
		<SaveWithPanelColorToggle />
	</PanelElement>);
}
